import { derived } from "svelte/store";
import { userStore } from "../../../../api-stores/user-store";

export const diallerRequestedStore = derived([userStore], ([$userStore]) => {
  const { diallerRequested = false } = $userStore || {}; // empty dict to prevent error
  return diallerRequested;
});
